import { styleEnquiryModal } from './enquiryModal'

function setUpMakeAnOfferOldLogin () {
  const makeAnOfferOldBtn = document.getElementById('vjs-make-an-offer-old-button')
  if (!makeAnOfferOldBtn) return

  makeAnOfferOldBtn.addEventListener('click', () => {
    document.getElementById('vjs-login-modal-purpose').value = 'make-an-offer-old'
  })
}

function showMakeAnOfferOldModalAfterLogin () {
  const makeAnOfferOldFlag = document.querySelector('[data-id="make-an-offer-old-should-open"]')
  const makeAnOfferOldModal = document.getElementById('enquiry-modal')
  const makeAnOfferOldBtn = document.getElementById('vjs-make-an-offer-old-button')

  if (!makeAnOfferOldFlag) return
  if (!makeAnOfferOldModal) return
  if (!makeAnOfferOldBtn) return

  styleEnquiryModal(makeAnOfferOldBtn.dataset.enquiry)
  makeAnOfferOldModal.classList.add('show')
}

export default function setUpMakeAnOfferOld () {
  setUpMakeAnOfferOldLogin()
  showMakeAnOfferOldModalAfterLogin()
}
